import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-home',
  templateUrl: './icon-home.component.html',
  styleUrls: ['./icon-home.component.scss'],
})
export class IconHomeComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
